import React from 'react';

import AlertIcon from '@hero/ui-kit/icons/utility/AlertIcon';
import Button from '@hero/ui-kit/inputs/Button';
import P from '@hero/ui-kit/typography/P';
import disengagedDictionary from '../../DisengagedMembers/disengagedDictionary';
import { DisengagedReason } from '../../types';
import * as Style from './style.module.scss';

interface Props {
    reason: DisengagedReason | null;
}

const DisengageHeaderNote: React.FC<Props> = ({ reason }) => {
    const [showGuide, setShowGuide] = React.useState(false);

    if (!reason) {
        return null;
    }

    return (
        <div className={Style.wrapper}>
            <div className={Style.inner}>
                <AlertIcon size="utility" />
                <div>
                    <P noDefaultMargin strong>
                        Member is disengaged
                    </P>

                    <P noDefaultMargin>Reason: {disengagedDictionary[reason].label} </P>
                </div>
            </div>

            <Button noDefaultMargin size="small" onClick={() => setShowGuide(!showGuide)}>
                {showGuide ? 'Hide' : 'Show'} resolution steps
            </Button>

            {showGuide && (
                <div className={Style.guide}>{disengagedDictionary[reason].resolutionSteps}</div>
            )}
        </div>
    );
};

export default DisengageHeaderNote;
